import Link from 'next/link'

import { Button } from '@wartek-id/button-v1'
import { Card } from '@wartek-id/card'
import { Text } from '@wartek-id/text-v1'

import CircularProgress from 'app/KinerjaShared/components/CircularProgress'
import { CardHeader } from 'app/KinerjaKSPage/components/CardHeader'
import CardPelaksanaanOther from 'app/KinerjaKSPage/components/CardPelaksanaanOther'
import useSchoolContext from 'app/KinerjaKSPage/hooks/useSchoolContext'
import useSKPKSPelaksanaanTrackEvent from 'app/KinerjaKSPage/hooks/useSKPKSPelaksanaanTrackEvent'
import { assetUrl } from 'utils/url'
import CardPeriodType from 'app/KinerjaShared/components/CardPeriodType'
import { PENGELOLAAN_KINERJA_KS_PEGAWAI_PATH } from 'app/KinerjaShared/constants/path'
import Before2025 from 'app/KinerjaShared/components/Before2025'
import { useNewDocumentFlow } from 'app/KinerjaShared/hooks/useNewDocumentFlow'
import useToggleSdkContext from 'utils/useToogleSdk'

import type { Pelaksanaan } from 'types/kinerja-ks-pelaksanaan'
import type { FC } from 'react'

interface CardPelaksanaanProps {
  data: Pelaksanaan
}

const urlPath = `${PENGELOLAAN_KINERJA_KS_PEGAWAI_PATH}/pelaksanaan`
const CardPelaksanaan: FC<CardPelaksanaanProps> = ({ data }) => {
  const toggles = useToggleSdkContext()
  const isPelaksanaanKsEnabled =
    toggles['kinerja-ks-pelaksanaan-enabled'] || false

  const { status: documentFlowStatus } = useNewDocumentFlow()

  const { currentNpsn } = useSchoolContext()
  const {
    trackClickKinerjaCekLangkahObservasi,
    trackClickKinerjaPelaksanaanPengembanganKompetensi,
  } = useSKPKSPelaksanaanTrackEvent()

  return (
    <>
      <Card>
        <CardHeader />

        <section className="px-9 pt-6 pb-9 space-y-9 border-t border-gray-30">
          {/* Lakukan Observasi */}
          <div className="space-y-2 max-w-[437px]">
            <Text variant="heading-sm">Lakukan Praktik Kinerja:</Text>

            <div className="border border-subdued rounded-lg flex items-start content-start gap-6 p-6">
              <div className="w-[84px] h-[84px]">
                <CircularProgress
                  value={data?.progressPercentage || 0}
                  maxValue={100}
                  percentage
                />
              </div>
              <div className="flex flex-col items-start gap-[5px]">
                <Text variant="heading-sm">Praktik Kinerja</Text>
                <Before2025>
                  <Text color="subdued">
                    Periode: <CardPeriodType withYear type="all" />.
                  </Text>
                </Before2025>

                <Link href={`${urlPath}/beranda?id=${currentNpsn}`} passHref>
                  <Button
                    as="a"
                    disabled={!isPelaksanaanKsEnabled}
                    onClick={() => {
                      if (!isPelaksanaanKsEnabled) return

                      trackClickKinerjaCekLangkahObservasi({
                        kinerja_pelaksanaan_id: data.id,
                        pelaksanaan_observasi_completion:
                          data.progressPercentage,
                      })
                    }}
                  >
                    {isPelaksanaanKsEnabled
                      ? 'Cek Praktik Kinerja'
                      : 'Sedang diperbarui'}
                  </Button>
                </Link>
              </div>
            </div>
          </div>

          {/* Kumpulkan Dokumen */}
          <div className="space-y-2 max-w-[437px]">
            <Text variant="heading-sm">Kumpulkan dokumen:</Text>

            <div className="border border-subdued rounded-lg flex items-start content-start gap-6 p-6">
              <div className="w-[84px] flex justify-center">
                <img
                  src={assetUrl('/illustrations/img-document.png')}
                  alt=""
                  width={64}
                  height={64}
                />
              </div>

              <div className="flex flex-col gap-2 items-start">
                <Text variant="heading-sm">Pengembangan Kompetensi</Text>

                <Link
                  href={`${urlPath}/pengembangan-kompetensi?id=${currentNpsn}`}
                  passHref
                >
                  <Button
                    as="a"
                    disabled={documentFlowStatus === 'DISABLED'}
                    onClick={() => {
                      trackClickKinerjaPelaksanaanPengembanganKompetensi({
                        kinerja_pelaksanaan_id: data.id,
                        pelaksanaan_observasi_completion:
                          data.progressPercentage,
                      })
                    }}
                  >
                    {documentFlowStatus === 'OLD_DOCUMENT_FLOW' ? (
                      <>
                        Kumpulkan
                        <span className="sr-only">
                          dokumen Pengembangan Kompetensi
                        </span>
                      </>
                    ) : documentFlowStatus === 'NEW_DOCUMENT_FLOW' ? (
                      <>
                        Lakukan
                        <span className="sr-only">
                          pengumpulan Pengembangan Kompetensi
                        </span>
                      </>
                    ) : (
                      <>
                        <span className="sr-only">
                          Dokumen Pengembangan Kompetensi
                        </span>
                        Sedang diperbarui
                      </>
                    )}
                  </Button>
                </Link>
              </div>
            </div>
          </div>

          <CardPelaksanaanOther urlPath={urlPath} />
        </section>
      </Card>
    </>
  )
}
export default CardPelaksanaan
